<template>
  <div class="color-sku-item">
    <a-space>
       <span>
      {{ item.value }}
      </span>
    </a-space>

    <!--    <a-icon type="close" class="operate-button"/>-->
    <span class="operate-button" @click="remove">
      删除
    </span>
  </div>
</template>

<script>
export default {
  name: 'SizeSkuItem',
  props: {
    item: Object,
  },
  methods: {
    remove() {
      this.$emit('onRemove', this.item);
    },
  },
};
</script>

<style scoped>
.color-sku-item {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.color-sku-item:hover .operate-button {
  display: block;
}

.operate-button {
  cursor: pointer;
  color: #f5222d;
}
</style>
